export default "/images/cf97713af2811b4180a28086897b0861.avif";